import { useEffect, useState, type ReactNode } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';

/** L13.03 — Billing Claim Detail: view claim lines, invoice, status. */
export function VendorBillingDetailPage(): ReactNode {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const { token } = useAuth();
  const [claim, setClaim] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<any>(`/v1/vendor/billing/claims/${invoiceId}`, { token })
      .then(r => { if (alive) setClaim(r); })
      .catch(e => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [invoiceId, token]);

  if (error) return <div style={{ padding: 24 }}><p style={{ color: 'red' }}>{error}</p></div>;
  if (!claim) return <div style={{ padding: 24 }}><p>Loading...</p></div>;

  return (
    <div style={{ padding: 24 }}>
      <h1>Claim: {claim.claimNumber}</h1>
      <p>
        <Link to={`/vendor/portal/billing/${invoiceId}/invoice`} style={{ color: '#0969da' }}>
          View / print tax invoice
        </Link>
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16, maxWidth: 600 }}>
        <div><strong>Status:</strong> {claim.status}</div>
        <div><strong>Period:</strong> {claim.billingPeriodFrom} – {claim.billingPeriodTo}</div>
        <div><strong>Basic Amount:</strong> ₹{(claim.totalBasicAmount ?? 0).toLocaleString('en-IN')}</div>
        <div><strong>Tax:</strong> ₹{(claim.totalTaxAmount ?? 0).toLocaleString('en-IN')}</div>
        <div><strong>Total:</strong> ₹{(claim.totalClaimAmount ?? 0).toLocaleString('en-IN')}</div>
        <div><strong>Submitted:</strong> {claim.submissionDate ? new Date(claim.submissionDate).toLocaleDateString() : '—'}</div>
      </div>
      {claim.lines && claim.lines.length > 0 && (
        <>
          <h3>Lines ({claim.lines.length})</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 16 }}>
            <thead>
              <tr style={{ background: '#f6f8fa', borderBottom: '1px solid #d0d7de' }}>
                <th style={{ padding: 6, textAlign: 'left' }}>Job</th>
                <th style={{ padding: 6, textAlign: 'left' }}>Work Type</th>
                <th style={{ padding: 6, textAlign: 'right' }}>Area (sqft)</th>
                <th style={{ padding: 6, textAlign: 'right' }}>Rate</th>
                <th style={{ padding: 6, textAlign: 'right' }}>Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              {claim.lines.map((l: any, i: number) => (
                <tr key={l.lineId ?? i} style={{ borderBottom: '1px solid #d0d7de' }}>
                  <td style={{ padding: 6 }}>{l.jobRequestId?.substring(0, 8)}</td>
                  <td style={{ padding: 6 }}>{l.workTypeCode}</td>
                  <td style={{ padding: 6, textAlign: 'right' }}>{l.areaSqft}</td>
                  <td style={{ padding: 6, textAlign: 'right' }}>{l.ratePerUnit}</td>
                  <td style={{ padding: 6, textAlign: 'right' }}>{(l.basicAmount ?? 0).toLocaleString('en-IN')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
